// extracted by mini-css-extract-plugin
export default {"container":"transaction_container__TFD6p","imageContainer":"transaction_imageContainer__XeAID","time":"transaction_time__3cUTv","arrow":"transaction_arrow__pWgDc"};